import { render } from "./ThanksPopup.vue?vue&type=template&id=2c89feef"
import script from "./ThanksPopup.vue?vue&type=script&lang=js"
export * from "./ThanksPopup.vue?vue&type=script&lang=js"

import "./ThanksPopup.vue?vue&type=style&index=0&id=2c89feef&lang=sass"

import exportComponent from "D:\\Open Server 5.3.5\\OSPanel\\domains\\front\\personal_form\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__